import { jsx as _jsx } from "react/jsx-runtime";
import { Collapsible as BaseCollapsible } from "@base-ui/react/collapsible";
import { cn } from "../lib/utils.js";
function Collapsible({ ...props }) {
    return _jsx(BaseCollapsible.Root, { "data-slot": "collapsible", ...props });
}
function CollapsibleTrigger({ ...props }) {
    return _jsx(BaseCollapsible.Trigger, { "data-slot": "collapsible-trigger", ...props });
}
function CollapsibleContent({ className, ...props }) {
    return (_jsx(BaseCollapsible.Panel, { "data-slot": "collapsible-content", className: cn("h-(--collapsible-panel-height) overflow-hidden transition-all duration-200 data-ending-style:h-0 data-starting-style:h-0 [&[hidden]:not([hidden='until-found'])]:hidden", className), ...props }));
}
export { Collapsible, CollapsibleTrigger, CollapsibleContent };
//# sourceMappingURL=Collapsible.js.map